export const en = {
    copied: 'Copied',
    'copy-error': 'Error copying',
    'copy-link': 'Copy criteria to the clipboard',
    'open-popup-text': 'View criteria',
    'popup-title': 'Existing criteria'
};
